import Vue from 'vue';
import Vuex from 'vuex';
import searchHistory from './modules/search-history';
import address from './modules/address';
import publicStore from './modules/public';
import persistSearchHistoryPlugin from './plugins/persistSearchHistoryPlugin';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [persistSearchHistoryPlugin],
  modules: {
    searchHistory,
    address,
    publicStore,
  },
});
